// LAP-733 (GE022) — Ajouter une opportunité directement depuis une liste de
// valeurs (onglet Marché), sans dupliquer le formulaire déjà utilisé dans
// Portfolio/OpportunityCard : on le réutilise avec des champs pré-remplis
// (nom, prix, secteur...) et un déclencheur compact adapté aux listes denses.
import React, { useState } from 'react'
import { Alert, IconButton, Snackbar, Tooltip } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { useTranslation } from 'react-i18next'
import CreateOpportunityForm from '../Portfolio/cards/CreateOpportunityForm'

export default function AddOpportunityAction({ initialValues, size = 'small', sx = {} }) {
  const { t } = useTranslation('layout')
  const [feedback, setFeedback] = useState(null) // 'success' | 'error' | null

  return (
    <>
      <Tooltip title={t('investments.markeet.addOpportunity')}>
        <span>
          <CreateOpportunityForm
            initialValues={initialValues}
            trigger={
              <IconButton
                size={size}
                sx={{ color: 'rgba(255,255,255,0.7)', padding: 0.25, ...sx }}
                onClick={(event) => event.stopPropagation()}
              >
                <AddCircleOutlineIcon fontSize={size} />
              </IconButton>
            }
            onCreated={() => setFeedback('success')}
            onError={() => setFeedback('error')}
          />
        </span>
      </Tooltip>
      <Snackbar
        open={!!feedback}
        autoHideDuration={3000}
        onClose={() => setFeedback(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setFeedback(null)}
          severity={feedback === 'error' ? 'error' : 'success'}
          sx={{ width: '100%' }}
        >
          {feedback === 'error'
            ? t('investments.markeet.addOpportunityError')
            : t('investments.markeet.addOpportunitySuccess')}
        </Alert>
      </Snackbar>
    </>
  )
}
